import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Home from '@/pages/home/Index'
import Signin from '@/pages/auth/Signin'
import PeopleIndex from '@/pages/person/Index'
import PeopleDetail from '@/pages/person/Detail'
import EventIndex from '@/pages/event/Index'
import EventDetail from '@/pages/event/Detail'
import OrganizationIndex from '@/pages/organization/Index'
import OrganizationDetail from '@/pages/organization/Detail'
import ProjectIndex from '@/pages/project/Index'
import ProjectDetail from '@/pages/project/Detail'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      meta: { auth: true },
      path: '/',
      component: Home
    },
    {
      path: '/signin',
      component: Signin
    },
    {
      meta: { auth: true },
      path: '/person',
      component: PeopleIndex
    },
    {
      meta: { auth: true },
      path: '/person/detail/:id',
      name: 'person-detail',
      component: PeopleDetail
    },
    {
      meta: { auth: true },
      path: '/event',
      component: EventIndex
    },
    {
      meta: { auth: true },
      path: '/event/detail/:id',
      name: 'event-detail',
      component: EventDetail
    },
    {
      meta: { auth: true },
      path: '/organization',
      component: OrganizationIndex
    },
    {
      meta: { auth: true },
      path: '/organization/detail/:id',
      name: 'organization-detail',
      component: OrganizationDetail
    },
    {
      meta: { auth: true },
      path: '/project',
      component: ProjectIndex
    },
    {
      meta: { auth: true },
      path: '/project/detail/:id',
      name: 'project-detail',
      component: ProjectDetail
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters['auth/isAuthenticated']) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js